import {WithoutSummaryModel} from '../../../../common/entity/dto/plain/withoutSummary.model';
import {ConsultationSummaryModel} from '../../../consultation/consultation/api/model/consultationSummary.model';
import {PartnerSummaryModel} from '../../../../partner/common/api/model/partnerSummary.model';
import {Moment} from 'moment';

export class MedicalMorphologyModel extends WithoutSummaryModel {
    consultation: ConsultationSummaryModel;
    partner: PartnerSummaryModel;
    date: Moment;
    height: number;
    weight: number;
    shoeSize: number;
    comment: string;
}
